import { RouteObject } from 'react-router-dom'
import { default as Reports } from '.'
import { PageLayout } from '$components/common'

const basePath = '/stock'
export const stockReportsRoutes: RouteObject[] = [
  {
    path: `${basePath}/reports/received-invoices`,
    element: (
      <PageLayout title="Received Invoices">
        <Reports.ReceivedInvoices.Component />
      </PageLayout>
    ),
    loader: Reports.ReceivedInvoices.Loader,
  },
  {
    path: `${basePath}/statements`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Reports.Statements.Component />
      </PageLayout>
    ),
    loader: Reports.Statements.Loader,
  },
  {
    path: `${basePath}/statements/:statementId`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Reports.Statements.EditSupplierStatement.Component />
      </PageLayout>
    ),
    loader: Reports.Statements.EditSupplierStatement.Loader,
  },
  {
    path: `${basePath}/statements/add`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Reports.Statements.AddSupplierStatement.Component />
      </PageLayout>
    ),
    loader: Reports.Statements.AddSupplierStatement.Loader,
  },
  {
    path: `${basePath}/reports/received-invoices/export`,
    element: (
      <PageLayout title="Export Invoices">
        <Reports.Statements.AccountingSystemExport.Component />
      </PageLayout>
    ),
    loader: Reports.Statements.AccountingSystemExport.Loader,
  },
  {
    path: `${basePath}/reports/received-invoices/export-to`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Reports.Statements.ExportTo.Component />
      </PageLayout>
    ),
    loader: Reports.Statements.ExportTo.Loader,
  },
  {
    path: `${basePath}/stock-on-hand`,
    element: (
      <PageLayout title="Stock On Hand" displayLeftTitle={false}>
        <Reports.StockOnHand.Component />
      </PageLayout>
    ),
    loader: Reports.StockOnHand.Loader,
  },
]
